import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useTranslation } from "react-i18next";
import { ThirdPartyTreeNode, useAgentHierarchy } from "layouts/shared/AgentManagementShared";

function AgentManagementPage({ title }) {
  const { t } = useTranslation("agentManagement");
  const { hierarchyData, isLoading, error } = useAgentHierarchy();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <MDTypography variant="h6" color="white">
                  {title}
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                {isLoading ? (
                  <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
                    <CircularProgress />
                  </Box>
                ) : error ? (
                  <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
                    <Typography color="error">{error}</Typography>
                  </Box>
                ) : !hierarchyData?.MatchedNode ? (
                  <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
                    <Typography>{t("states.noData")}</Typography>
                  </Box>
                ) : (
                  <Box sx={{ maxHeight: "70vh", overflow: "auto", p: 1 }}>
                    <ThirdPartyTreeNode node={hierarchyData.MatchedNode} t={t} />
                  </Box>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

AgentManagementPage.propTypes = {
  title: PropTypes.string.isRequired,
};

export default AgentManagementPage;
